import { Icon } from "@iconify/react";
import { forwardRef, useState } from "react";
import Pagination from "../Pagination";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import {
  createCurrency,
  getHistoryEditVariance,
  updateCurrency,
} from "../../../callApi/httpservice";
import SpinnerCustom from "../../common/SpinnerCustom";
import SkeletonTable from "../../common/SkeletonTable";
import { useStores } from "../../../srores";
import { toast } from "react-toastify";
import { validateVariance } from "../../../utils/validate-date";
interface ComponentProps {
  items: any;
  offset: number;
  pageCount: number;
  handlePageClick: any;
  setStartDate: any;
  setEndDate: any;
  setItemEdit: any;
  itemEdit: any;
  newVariance: any;
  setNewVariance: any;
  startDate: any;
  endDate: any;
  newVarianceErr: string;
  dateMessageErr: string;
  onSaveUpdatingVarianceClick: any;
  setEditCurrencyModal: any;
  editCurrencyModal: boolean;
  setItems: any;
  isWaitingSaving: boolean;
  isFetching: boolean;
  setEditIndexModal: any;
  editIndexModal: boolean;
  onSaveUpdateIndexClick: any;
  newIndex: any;
  setNewIndex: any;
  newIndexErr: string;
  callApiGetCurrencies: any;
  take: number;
  skip: number;
}
export default function CurrencySettingTable(props: ComponentProps) {
  const { adminStore } = useStores();
  /*
   * Props of Component
   */
  const {
    items,
    offset,
    pageCount,
    handlePageClick,
    setStartDate,
    setEndDate,
    setItemEdit,
    itemEdit,
    newVariance,
    setNewVariance,
    startDate,
    endDate,
    newVarianceErr,
    dateMessageErr,
    onSaveUpdatingVarianceClick,
    setEditCurrencyModal,
    editCurrencyModal,
    setItems,
    isWaitingSaving,
    isFetching,
    setEditIndexModal,
    editIndexModal,
    onSaveUpdateIndexClick,
    newIndex,
    setNewIndex,
    newIndexErr,
    callApiGetCurrencies,
    take,
    skip,
  } = props;

  const [isWaitingActive, setIsWaitingActive] = useState<boolean>(false);
  const [isWaitingPublic, setIsWaitingPublic] = useState<boolean>(false);
  const [codeIsUpdating, setCodeIsUpdating] = useState<string>("");
  const [varianceCreate, setVarianceCreate] = useState<string>("");
  const [varianceCreateErr, setVarianceCreateErr] = useState<string>("");
  const [currencyCode, setCurrencyCode] = useState<string>("");
  const [currencyCodeErr, setCurrencyCodeErr] = useState<string>("");
  const [currencyName, setCurrencyName] = useState<string>("");
  const [currencyNameErr, setCurrencyNameErr] = useState<string>("");
  const [startDateCreate, setStartDateCreate] = useState<any>(new Date());
  const [endDateCreate, setEndDateCreate] = useState<any>(new Date());
  const [dateCreateErr, setDateCreateErr] = useState<string>("");
  const [isWaitingCreating, setIsWaitingCreating] = useState<boolean>(false);
  const [createCurrencyModal, setCreateCurrencyModal] =
    useState<boolean>(false);
  const [historyItems, setHistoryItems] = useState<any>(null);
  const customStyles = {
    content: {
      background: "white",
      top: adminStore.windowWidth > 768 ? "50%" : "40%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "none",
      width:
        adminStore.windowWidth > 1280
          ? "475px"
          : adminStore.windowWidth > 480
          ? "380px"
          : "90%",
      boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
      borderRadius: 10,
    },
  };

  const customStyles2 = {
    content: {
      background: "white",
      top: adminStore.windowWidth > 768 ? "50%" : "40%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      border: "none",
      width:
        adminStore.windowWidth > 1280
          ? "475px"
          : adminStore.windowWidth > 480
          ? "380px"
          : "90%",
      boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
      borderRadius: 10,
      height: adminStore.windowWidth > 480 ? "500px" : "420px",
    },
  };

  const Input = forwardRef(
    ({ onChange, placeholder, value, id, onClick }: any, ref) => (
      <div className="flex relative fullwidth-datepicker">
        <div className="w-[100%]">
          <input
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            id={id}
            onClick={onClick}
            style={{ border: "1px solid #EED484" }}
          />
        </div>
        <div className="absolute top-[13px] right-[5%]">
          <Icon
            icon="fluent-mdl2:page-list-filter"
            width={16}
            className=" cursor-pointer"
            onClick={onClick}
          />
        </div>
      </div>
    )
  );

  const InputOld = forwardRef(({ placeholder, value, id }: any, ref) => (
    <div className="flex relative fullwidth-datepicker">
      <div className="w-[100%]">
        <input
          placeholder={placeholder}
          value={value}
          id={id}
          style={{ backgroundColor: "#DFDFDF", color: "gray" }}
          readOnly
        />
      </div>
      <div className="absolute top-[13px] right-[5%]">
        <Icon
          icon="fluent-mdl2:page-list-filter"
          width={16}
          className=" cursor-pointer"
        />
      </div>
    </div>
  ));
  function onDateStartChange(date: any) {
    setStartDate(date);
  }
  function onDateEndChange(date: any) {
    setEndDate(date);
  }

  function onEndDateCreateChange(date: any) {
    setEndDateCreate(date);
  }

  function onStartDateCreateChange(date: any) {
    setStartDateCreate(date);
  }
  const onSelectPublicOnWebChange = async (code: string, event: any) => {
    setIsWaitingPublic(true);
    setCodeIsUpdating(code);
    const result = await updateCurrency(code, { public: event.target.checked });
    let newItems = items;
    if (result.status === 200) {
      for (let i = 0; i < newItems.length; i++) {
        if (newItems[i].code === code) {
          newItems[i] = result.data;
          break;
        }
      }
      setItems(newItems);
      setIsWaitingPublic(false);
      setCodeIsUpdating("");
      //toast.success("Public on web field updated successfully");
    } else {
      //toast.error("Updating error");
    }
  };
  const closeModal = () => {
    setEditCurrencyModal(false);
  };
  const closeIndexModal = () => {
    setEditIndexModal(false);
  };
  const closeModalCreateCurrency = () => {
    setCreateCurrencyModal(false);
  };
  const onSelectActiveChange = async (code: string, event: any) => {
    setIsWaitingActive(true);
    setCodeIsUpdating(code);
    const result = await updateCurrency(code, { active: event.target.checked });
    let newItems = items;
    if (result.status === 200) {
      for (let i = 0; i < newItems.length; i++) {
        if (newItems[i].code === code) {
          newItems[i] = result.data;
          break;
        }
      }
      setItems(newItems);
      setIsWaitingActive(false);
      setCodeIsUpdating("");
      //toast.success("Active field updated successfully");
    } else {
      // toast.error("Updating error");
    }
  };

  const collums = [
    "Public on web",
    // "Active",
    "Priority",
    "Currency code",
    "Currency name",
    "Local currency",
    "Variance",
    "Apply time (variance)",
  ];

  const historyCollums = ["Code", "Variance", "Apply time"];
  const onEditVarianceClick = async (item: any) => {
    setHistoryItems(null);
    const histories: any = await getHistoryEditVariance(
      {
        take: 100,
        skip: 0,
        sortDesc: true,
        sortBy: "createdAt",
      },
      item.code
    );
    setHistoryItems(histories.data[0]);
    setEditCurrencyModal(true);
    setItemEdit(item);
    const date = _getDate(item.varianceStartAt);
    setStartDate(new Date(date));
    setEndDate(new Date(item.varianceEndAt));
  };
  const _getDate = (varianceStart: string) => {
    if (new Date(varianceStart) < new Date()) {
      if (new Date() > new Date(new Date().setHours(8, 30, 0, 0))) {
        return new Date().setDate(new Date().getDate() + 1);
      } else {
        return new Date();
      }
    } else {
      return new Date(varianceStart);
    }
  };
  const onEditIndexClick = (item: any) => {
    setEditIndexModal(true);
    setItemEdit(item);
  };
  const onCreateCurrencyClick = async () => {
    const checkValid = validate();
    setIsWaitingCreating(true);
    if (checkValid) {
      try {
        const body = {
          code: currencyCode,
          name: currencyName,
          variance: +varianceCreate,
          varianceStartAt: new Date(startDateCreate.setHours(0, 0, 0, 0)),
          varianceEndAt: new Date(endDateCreate.setHours(23, 59, 59, 999)),
        };
        await createCurrency(body);
        callApiGetCurrencies(take, skip);
        setVarianceCreate("");
        setCurrencyCode("");
        setCurrencyName("");
        setCreateCurrencyModal(false);
      } catch (err: any) {
        if (err.response.status === 409) {
          toast.error("Currency already exists");
        } else {
          toast.error("Can not create currency, contact admin");
        }
      }
    }
    setIsWaitingCreating(false);
  };
  const validate = () => {
    setCurrencyCodeErr("");
    setCurrencyNameErr("");
    setVarianceCreateErr("");
    setDateCreateErr("");
    let msg: any = {};
    if (currencyCode.trim() === "") {
      msg.currencyCode = "Currency code is required";
      setCurrencyCodeErr("Currency code is required");
    }
    if (currencyName.trim() === "") {
      msg.currencyName = "Currency name is required";
      setCurrencyNameErr("Currency name is required");
    }
    if (varianceCreate.trim() === "") {
      msg.varianceCreate = "Variance is required";
      setVarianceCreateErr("Variance is required");
    }
    if (varianceCreate.trim() !== "") {
      if (+varianceCreate < 0) {
        msg.varianceCreate = "Variance is not less than zero";
        setVarianceCreateErr("Variance is not less than zero");
      }
      if (+varianceCreate >= 100) {
        msg.varianceCreate = "Variance is not greater than or equal to 100";
        setVarianceCreateErr("Variance is not greater than or equal to 100");
      }
    }
    if (new Date(endDateCreate) <= new Date(startDateCreate)) {
      msg.endDate = "This date is not valid";
      setDateCreateErr("This date is not valid");
    }

    if (Object.keys(msg).length > 0) return false;
    return true;
  };
  return (
    <div>
      <div className="flex justify-between items-center">
        <div className=" text-[#242424] justify-between font-bold xsm:text-[16px] xs:text-[18px]">
          {"Currency setting"}
        </div>
        <Icon
          icon="material-symbols:add-notes-outline"
          width={40}
          className=" bg-[#EED484] hover:bg-[#dac176] cursor-pointer rounded-lg p-1"
          onClick={() => setCreateCurrencyModal(true)}
        />
      </div>
      <hr className="mt-3" />
      <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className=" pt-2 w-full inline-block align-middle">
            <div className=" xl:overflow-hidden xsm:overflow-x-scroll border rounded-lg">
              <table className="min-w-full xl:overflow-hidden xsm:overflow-x-scroll">
                <thead className="bg-[#222221]">
                  <tr className="text-[#EED484] text-center font-bold text-xs">
                    {collums.map((collum, index: any) => (
                      <th scope="col" className="px-6 py-3" key={index}>
                        {collum}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="">
                  {items &&
                    items.map((item: any, index: number) => (
                      <tr
                        className={
                          (index + 1) % 2
                            ? "text-[#222221] text-center bg-white"
                            : " text-[#222221] text-center bg-[#E0E0E0]"
                        }
                        key={index}
                      >
                        <td className="public-on-web">
                          {isWaitingPublic && codeIsUpdating === item.code ? (
                            <SpinnerCustom />
                          ) : (
                            <input
                              type="checkbox"
                              defaultChecked={item.public}
                              value={item.code}
                              onChange={(e) => {
                                onSelectPublicOnWebChange(item.code, e);
                              }}
                            />
                          )}
                        </td>
                        {/* <td className="public-on-web">
                          {isWaitingActive && codeIsUpdating === item.code ? (
                            <SpinnerCustom />
                          ) : (
                            <input
                              type="checkbox"
                              defaultChecked={item.active}
                              value={item.code}
                              onChange={(e) => {
                                onSelectActiveChange(item.code, e);
                              }}
                            />
                          )}
                        </td> */}
                        <td className="px-6 py-4 ">
                          <div className="flex items-center">
                            <div className=" text-center flex justify-center w-[100%]">
                              {item.index}
                            </div>
                            <div
                              className="flex items-center justify-end cursor-pointer"
                              onClick={() => {
                                onEditIndexClick(item);
                              }}
                            >
                              <Icon
                                icon={"material-symbols:edit"}
                                width={adminStore.windowWidth > 480 ? 18 : 15}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 ">{item.code}</td>
                        <td className="px-6 py-4 ">{item.name}</td>
                        <td className="px-6 py-4  ">{item.local}</td>
                        <td className="px-6 py-4  ">
                          <div className="flex items-center">
                            <div className=" text-center flex justify-center w-[100%]">
                              {item.variance ? item.variance : 0}%
                            </div>
                            <div
                              className="flex items-center justify-end cursor-pointer"
                              onClick={() => {
                                onEditVarianceClick(item);
                              }}
                            >
                              <Icon
                                icon={"material-symbols:edit"}
                                width={adminStore.windowWidth > 480 ? 18 : 15}
                              />
                            </div>
                          </div>
                        </td>
                        <td
                          className={
                            validateVariance(item.varianceEndAt)
                              ? "px-6 py-4"
                              : "px-6 py-4 text-[#A6192E]"
                          }
                        >
                          {format(
                            new Date(item.varianceStartAt),
                            "dd/MM/yyyy"
                          ) +
                            "-" +
                            format(new Date(item.varianceEndAt), "dd/MM/yyyy")}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {isFetching && !items && (
        <div className="mt-5">
          <SkeletonTable row={5} />
        </div>
      )}
      {!isFetching && !items && (
        <div className="text-center text-black mt-10">Data is empty!</div>
      )}
      <div className=" flex justify-end xsm:mt-0 xs:mt-2 items-center">
        {pageCount > 0 && (
          <div className="flex items-center justify-center">
            <Pagination
              pageCount={pageCount}
              handlePageClick={handlePageClick}
              offset={offset}
            />
          </div>
        )}
      </div>
      <Modal
        isOpen={editCurrencyModal}
        onRequestClose={closeModal}
        style={customStyles2}
        contentLabel="Edit currency modal"
        ariaHideApp={false}
      >
        <div className="flex flex-col p-2">
          <div className="flex justify-between">
            <div className="text-xl">Update variance</div>
            <Icon
              icon={"ic:round-close"}
              width={20}
              className=" cursor-pointer hover:text-zinc-600"
              onClick={closeModal}
            />
          </div>
          <div className="flex flex-col mt-7 text-[14px]">
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="old-variance"
              >
                Current variance (%)
              </label>
              <input
                className="bg-[#DFDFDF] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="old-variance"
                type="number"
                placeholder={itemEdit?.variance ? itemEdit?.variance : 0}
                readOnly
              />
            </div>
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="new-variance"
              >
                New variance (%)
              </label>
              <input
                className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                style={{ border: "1px solid #EED484" }}
                id="new-variance"
                type="number"
                min={0}
                max={100}
                value={newVariance}
                onChange={(e) => {
                  setNewVariance(e.target.value);
                }}
              />
              <div className="text-[12px] text-red-500">{newVarianceErr}</div>
            </div>
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="new-variance"
              >
                Current period
              </label>
              <div className="flex items-center gap-2">
                <DatePicker
                  customInput={<InputOld />}
                  dateFormat="dd/MM/yyyy"
                  selected={new Date(itemEdit?.varianceStartAt)}
                  onChange={() => {}}
                  popperPlacement="bottom-start"
                  calendarStartDay={1}
                  readOnly
                />
                To
                <DatePicker
                  customInput={<InputOld />}
                  dateFormat="dd/MM/yyyy"
                  selected={new Date(itemEdit?.varianceEndAt)}
                  onChange={() => {}}
                  popperPlacement="bottom-end"
                  calendarStartDay={1}
                  readOnly
                />
              </div>
            </div>
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="new-variance"
              >
                New period
              </label>
              <div className="flex items-center gap-2">
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => onDateStartChange(date)}
                  popperPlacement="bottom-start"
                  calendarStartDay={1}
                  minDate={new Date(_getDate(`${new Date()}`))}
                />
                To
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  onChange={(date) => onDateEndChange(date)}
                  popperPlacement="bottom-end"
                  calendarStartDay={1}
                />
              </div>
              <div className="text-[12px] text-red-500">{dateMessageErr}</div>
            </div>
          </div>
          <div className="flex justify-center mt-7 items-center">
            <div
              className="bg-[#EED484] text-[14px] items-center py-2 px-10 rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2"
              style={{
                pointerEvents: `${isWaitingSaving ? "none" : "unset"}`,
              }}
              onClick={onSaveUpdatingVarianceClick}
            >
              {isWaitingSaving ? (
                <SpinnerCustom />
              ) : (
                <span className=" mr-2">&rsaquo; </span>
              )}
              Save change
            </div>
          </div>
          <div className="flex text-center mt-2 font-bold">
            Revision history
          </div>
          <div className="xl:overflow-hidden xsm:overflow-x-scroll border rounded-lg xsm:text-[12px] xs:text-[14px]">
            <table className="min-w-full xl:overflow-hidden xsm:overflow-x-scroll">
              <thead className="bg-[#222221]">
                <tr className="text-[#EED484] text-center font-bold text-xs">
                  {historyCollums.map((collum, index: any) => (
                    <th scope="col" className="px-6 py-3" key={index}>
                      {collum}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="">
                {historyItems ? (
                  historyItems.map((item: any, index: number) => (
                    <tr
                      className={
                        (index + 1) % 2
                          ? "text-[#222221] text-center bg-white"
                          : " text-[#222221] text-center bg-[#E0E0E0]"
                      }
                      key={index}
                    >
                      <td className="px-6 py-4 ">{item.code}</td>
                      <td className="px-6 py-4 ">{item.variance}%</td>
                      <td className="px-6 py-4 ">
                        {format(new Date(item.varianceStartAt), "dd/MM/yyyy") +
                          "-" +
                          format(new Date(item.varianceEndAt), "dd/MM/yyyy")}
                      </td>
                    </tr>
                  ))
                ) : (
                  <span className="text-center text-black">Empty data</span>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={editIndexModal}
        onRequestClose={closeIndexModal}
        style={customStyles}
        contentLabel="Edit index modal"
        ariaHideApp={false}
      >
        <div className="flex flex-col p-2 ">
          <div className="flex justify-between">
            <div className="text-xl">Update Priority</div>
            <Icon
              icon={"ic:round-close"}
              width={20}
              className=" cursor-pointer hover:text-zinc-600"
              onClick={closeIndexModal}
            />
          </div>
          <div className="flex flex-col mt-7 text-[14px]">
            <div className="mb-4 w-full">
              <label className="block text-gray-700 mb-1" htmlFor="old-index">
                Current index
              </label>
              <input
                className="bg-[#DFDFDF] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="old-index"
                type="number"
                placeholder={itemEdit?.index ? itemEdit?.index : 0}
                readOnly
              />
            </div>
            <div className="mb-4 w-full">
              <label className="block text-gray-700 mb-1" htmlFor="new-index">
                New index
              </label>
              <input
                className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                style={{ border: "1px solid #EED484" }}
                id="new-index"
                type="number"
                min={0}
                max={100}
                value={newIndex}
                onChange={(e) => {
                  setNewIndex(e.target.value);
                }}
              />
              <div className="text-[12px] text-red-500">{newIndexErr}</div>
            </div>
          </div>
          <div className="flex justify-center mt-7 items-center">
            <div
              className="bg-[#EED484] text-[14px] items-center py-2 px-10 rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2"
              style={{
                pointerEvents: `${isWaitingSaving ? "none" : "unset"}`,
              }}
              onClick={onSaveUpdateIndexClick}
            >
              {isWaitingSaving ? (
                <SpinnerCustom />
              ) : (
                <span className="mr-2">&rsaquo; </span>
              )}
              Save change
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={createCurrencyModal}
        onRequestClose={closeModalCreateCurrency}
        style={customStyles}
        contentLabel="Create currency modal"
        ariaHideApp={false}
      >
        <div className="flex flex-col p-2">
          <div className="flex justify-between">
            <div className="text-xl">Create currency</div>
            <Icon
              icon={"ic:round-close"}
              width={20}
              className=" cursor-pointer hover:text-zinc-600"
              onClick={closeModalCreateCurrency}
            />
          </div>
          <div className="flex flex-col mt-7 text-[14px]">
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="currency-code"
              >
                Currency code
              </label>
              <input
                className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                style={{ border: "1px solid #EED484" }}
                id="currency-code"
                type="text"
                value={currencyCode}
                onChange={(e) => {
                  setCurrencyCode(e.target.value);
                }}
              />
              <div className="text-[12px] text-red-500">{currencyCodeErr}</div>
            </div>
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="currency-name"
              >
                Currency name
              </label>
              <input
                className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                style={{ border: "1px solid #EED484" }}
                id="currency-name"
                type="text"
                value={currencyName}
                onChange={(e) => {
                  setCurrencyName(e.target.value);
                }}
              />
              <div className="text-[12px] text-red-500">{currencyNameErr}</div>
            </div>
            <div className="mb-4 w-full">
              <label className="block text-gray-700 mb-1" htmlFor="variance">
                Variance
              </label>
              <input
                className="bg-[#F2F2F2] w-full appearance-none rounded-md py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                style={{ border: "1px solid #EED484" }}
                id="variance"
                type="number"
                min={0}
                max={100}
                value={varianceCreate}
                onChange={(e) => {
                  setVarianceCreate(e.target.value);
                }}
              />
              <div className="text-[12px] text-red-500">
                {varianceCreateErr}
              </div>
            </div>
            <div className="mb-4 w-full">
              <label
                className="block text-gray-700 mb-1"
                htmlFor="new-variance"
              >
                Period
              </label>
              <div className="flex items-center gap-2">
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={startDateCreate}
                  onChange={(date) => onStartDateCreateChange(date)}
                  popperPlacement="bottom-start"
                  calendarStartDay={1}
                />
                To
                <DatePicker
                  customInput={<Input />}
                  dateFormat="dd/MM/yyyy"
                  selected={endDateCreate}
                  onChange={(date) => onEndDateCreateChange(date)}
                  popperPlacement="bottom-end"
                  calendarStartDay={1}
                />
              </div>
              <div className="text-[12px] text-red-500">{dateCreateErr}</div>
            </div>
          </div>
          <div className="flex justify-center mt-7 items-center">
            <div
              className="bg-[#EED484] text-[14px] items-center py-2 px-10 rounded-2xl text-center hover:bg-[#dac176] cursor-pointer flex gap-2"
              style={{
                pointerEvents: `${isWaitingCreating ? "none" : "unset"}`,
              }}
              onClick={onCreateCurrencyClick}
            >
              {isWaitingCreating ? (
                <SpinnerCustom />
              ) : (
                <span className=" mr-2">&rsaquo; </span>
              )}
              Create currency
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
